import apiClient from './client';
import type {
  CreditBalance,
  CreditPackage,
  CreditRatios,
  CreditTransactionsParams,
  CreditTransactionsResponse,
} from '@/types/credits';

const DEFAULT_TRANSACTIONS_PAGE_SIZE = 20;

export const creditsApi = {
  getBalance: async (): Promise<CreditBalance> => {
    return apiClient.get('/credits/balance');
  },

  getTransactions: async (
    params: CreditTransactionsParams = {}
  ): Promise<CreditTransactionsResponse> => {
    return apiClient.get('/credits/transactions', {
      params: {
        page: params.page ?? 1,
        pageSize: params.pageSize ?? DEFAULT_TRANSACTIONS_PAGE_SIZE,
        type: params.type,
        unit: params.creditType,
        projectId: params.projectId,
        trackType: params.trackType,
        featureType: params.featureType,
        range: params.range,
        startDate: params.startDate,
        endDate: params.endDate,
        tzOffset: params.tzOffset,
      },
    });
  },

  getPackages: async (): Promise<CreditPackage[]> => {
    return apiClient.get('/credits/packages');
  },

  getRatios: async (): Promise<CreditRatios> => {
    return apiClient.get('/credits/ratios');
  },

  estimateCredits: async (params: {
    modelName: string;
    generationType: string;
    resolution?: string;
    duration?: number;
    n?: number;
    charCount?: number;
    generateAudio?: boolean;
    mode?: string;
    hasReference?: boolean;
    inputImageCount?: number;
    inputVideoDuration?: number;
    videoType?: string;
    width?: number;
    height?: number;
    scale?: string;
  }): Promise<{ estimatedCredits: number }> => {
    return apiClient.post('/credits/estimate', params) as Promise<{
      estimatedCredits: number;
    }>;
  },
};
